import { render } from "./role-set.vue?vue&type=template&id=76a7199a&scoped=true&ts=true"
import script from "./role-set.vue?vue&type=script&lang=ts"
export * from "./role-set.vue?vue&type=script&lang=ts"

import "./role-set.vue?vue&type=style&index=0&id=76a7199a&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76a7199a"]])

export default __exports__